export type HelpPointVideo = {
	id: number;
	title: string;
	description: string;
	releaseDate: Date;
	videoUrl: string;
	thumbnailUrl: string;
	categoryName: string
}

export type HelpPointPlaylistItem = {
	id: number,
	index: number;
	video: HelpPointVideo;
	categoryName: string,
	helpPointLocation: string,
	hasAlwaysVisibleHelpPoint: boolean
}

export type HelpPointLinkModel = {
	id: number,
	isAlwaysVisible: boolean,
	playlistItem: HelpPointPlaylistItem,
	linkIdentifier: string
}

export type HelpPointPlaylist = {
	id: number,
	items: HelpPointPlaylistItem[],
	categoryName: string
}

export type HelpPointCategory = {
	id: number,
	number: number;
	name: string;
	playlist: HelpPointPlaylist;
}

export const HelpPointCategoryNumberIconName = Object.freeze({
	1: "info",
	2: "dashboard",
	3: "search",
	4: "content_paste_search",
	5: "note_alt",
	6: "shopping_cart_checkout",
	7: "undo",
	8: "inventory",
	9: "forum",
	10: "sell",
	11: "videocam",
	12: "zoom_in_map",
	13: "launch",
	14: "app_registration",
	15: "timer",
});

export const HelpPointLinkIdentifier = Object.freeze({
	INFORMATION_SYSTEM_NOTIFICATIONS: "INFORMATION_SYSTEM_NOTIFICATIONS",
	DASHBOARD_NEWS: "DASHBOARD_NEWS",
	DASHBOARD_KPI: "DASHBOARD_KPI",
	VEHICLE_SEARCH: "VEHICLE_SEARCH",
	VEHICLE_SEARCH_WITH_CUSTOMER: "VEHICLE_SEARCH_WITH_CUSTOMER",
	VEHICLE_SEARCH_ADVANCED: "VEHICLE_SEARCH_ADVANCED",
	PRODUCT_SEARCH_BASIC_FUNCTIONS: "PRODUCT_SEARCH_BASIC_FUNCTIONS",
	PRODUCT_SEARCH_PRODUCT_DETAIL: "PRODUCT_SEARCH_PRODUCT_DETAIL",
	ILLUSTRATED_PART_SEARCH: "ILLUSTRATED_PART_SEARCH",
	CUSTOMER_MODE: "CUSTOMER_MODE",
	WATCHLIST_ADD_PRODUCT: "WATCHLIST_ADD_PRODUCT",
	WATCHLIST_PRINT: "WATCHLIST_PRINT",
	WATCHLIST_EXPORT: "WATCHLIST_EXPORT",
	ORDER_ADD_PRODUCT_TO_CART: "ORDER_ADD_PRODUCT_TO_CART",
	ORDER_CALCULATION: "ORDER_CALCULATION",
	ORDER_DISCOUNTS: "ORDER_DISCOUNTS",
	RESHIPMENT_REQUEST: "RESHIPMENT_REQUEST",
	RESHIPMENT_SEND: "RESHIPMENT_SEND",
	INSPECTION_LISTS: "INSPECTION_LISTS",
	SUSY_FIND_HELP: "SUSY_FIND_HELP",
	SUSY_CREATE_SUPPORT_TICKET: "SUSY_CREATE_SUPPORT_TICKET",
	SALES_PROMOTIONS: "SALES_PROMOTIONS",
	SUBARU_MEDIA_LIBRARY: "SUBARU_MEDIA_LIBRARY",
	WHEEL_CONFIGURATOR: "WHEEL_CONFIGURATOR",
	EXTERN_PLATFORMS: "EXTERN_PLATFORMS",
	PROPOSAL_ADD_TASKS_AND_SPARES: "PROPOSAL_ADD_TASKS_AND_SPARES",
	PROPOSAL_ADD_CONSUMABLES: "PROPOSAL_ADD_CONSUMABLES",
	PROPOSAL_IMPORT_INSPECTION_LIST: "PROPOSAL_IMPORT_INSPECTION_LIST",
	MAINTENANCE_GUIDE_TIMES_CATALOG: "MAINTENANCE_GUIDE_TIMES_CATALOG",
	MAINTENANCE_GUIDE_TIMES_SERVICE_BUNDLE_ADD_PRODUCT: "MAINTENANCE_GUIDE_TIMES_SERVICE_BUNDLE_ADD_PRODUCT",
});